module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale-65d5cafead9920d1b71e79ae08743688.png";